// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'PUT',
    endpoint: '/api/percorso-acquirenti/configurazione',
    requestBody: '{"societaId":"number","validitaMesiAtrio":"number","validitaMesiAran":"number"}',
    response: '{"success":true}'
  },
  {
    method: 'PUT',
    endpoint: '/api/percorso-acquirenti/sedi/:sedeId',
    requestBody: '{"urlPrenotazioni":"string","orari":"array","venditori":"array"}',
    response: '{"success":true}'
  },
  {
    method: 'GET',
    endpoint: '/api/percorso-acquirenti/configurazione?societaId',
    requestBody: null,
    response: '{"success":true,"data":{"configurazione":"object","sedi":"array","utenti":"array"}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
